module.exports = __webpack_public_path__ + "img/ANGEL SHADES LIME.96daf50.svg";